<template>
  <li
    v-if="!hide"
    :class="[
      'service-item',
      service.is_emergency_nav ? `service-item--emergency` : ``
    ]"
  >
    <component
      :is="service.is_url_target_blank ? 'a' : link"
      tag="h4"
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="h2 service-item__link fw-medium"
      :to="{ path: service.url }"
      :href="service.url"
      :target="link === `a` ? '_blank' : `` || service.is_url_target_blank ? '_blank' : ``"
    >
      <div :style="[service.description ? { paddingTop: '0.5em', width: '100%' } : {}]">
        <span class="service-item__title">{{
          service.label || service.name
        }}</span>
        <p
          v-if="service.description"
          class="small c-mid fsi"
          :style="{ maxWidth: '90%', marginTop: '10px' }"
        >
          {{ service.description }}
        </p>
      </div>

      <!-- <img class="service-item__icon" :src="icon" v-if="arrow" > -->
      <span :style="{ 'fill': org.custom_color1 == null ? '': org.custom_color1 }" class="service-item__homesvg" ><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="7" height="12"><defs><path id="a" d="M7.4 8l4.3 4.3a1 1 0 0 1-1.4 1.4l-5-5a1 1 0 0 1 0-1.4l5-5a1 1 0 0 1 1.4 1.4L7.4 8z"/></defs><use fill="" fill-rule="evenodd" transform="rotate(180 6 7)" xlink:href="#a"/></svg>
      </span>

    </component>
  </li>
</template>

<script>
import arrow from 'images/icons/arrow-right.svg';
import arrowEmergency from 'images/icons/arrow-right-emergency.svg';

// Vuex
import { mapGetters } from 'vuex';

const images = {
  arrow,
  arrowEmergency,
};

// Export
export default {
  name: 'module-service-item',

  // Props
  props: {
    service: Object,
    arrow: Boolean,
    hide: Boolean,
  },

  data() {
    return {
      icon: this.service.is_emergency_nav ? images.arrowEmergency : images.arrow,
    };
  },

  computed: {
    ...mapGetters('app', ['org']),
    link() {
      return this.service.url.search('http', 'www') === 0 ? 'a' : 'router-link';
    },
  },
};
</script>



// WEBPACK FOOTER //
// ServiceItem.vue?495c3fe1